import HomepageTable from './HomepageTable.vue';

export default HomepageTable;
